var map = {
	"./2c.png": 119,
	"./2d.png": 120,
	"./2h.png": 121,
	"./2s.png": 122,
	"./3c.png": 123,
	"./3d.png": 124,
	"./3h.png": 125,
	"./3s.png": 126,
	"./4c.png": 127,
	"./4d.png": 128,
	"./4h.png": 129,
	"./4s.png": 130,
	"./5c.png": 131,
	"./5d.png": 132,
	"./5h.png": 133,
	"./5s.png": 134,
	"./6c.png": 135,
	"./6d.png": 136,
	"./6h.png": 137,
	"./6s.png": 138,
	"./7c.png": 139,
	"./7d.png": 140,
	"./7h.png": 141,
	"./7s.png": 142,
	"./8c.png": 143,
	"./8d.png": 144,
	"./8h.png": 145,
	"./8s.png": 146,
	"./9c.png": 147,
	"./9d.png": 148,
	"./9h.png": 149,
	"./9s.png": 150,
	"./Ac.png": 151,
	"./Ad.png": 152,
	"./Ah.png": 153,
	"./As.png": 154,
	"./Jc.png": 155,
	"./Jd.png": 156,
	"./Jh.png": 157,
	"./Js.png": 158,
	"./Kc.png": 159,
	"./Kd.png": 160,
	"./Kh.png": 161,
	"./Ks.png": 162,
	"./Qc.png": 163,
	"./Qd.png": 164,
	"./Qh.png": 165,
	"./Qs.png": 166,
	"./Tc.png": 167,
	"./Td.png": 168,
	"./Th.png": 169,
	"./Ts.png": 170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;